import {MultiTargetRelation} from '../MultiTargetRelation';
import {SketchRelationKind} from '../../relation-compatibility/SketchRelationKinds';
import type {ISketchObject} from '../../../../../mesh/sketch/ISketchObject';

let count = 0;

/**
 * 判断对象是否为相等槽口约束。
 *
 * @param value 待判断对象。
 * @returns 是否为相等槽口约束。
 */
export function isSlotEqualConstraint(value: object): value is SlotEqualConstraint {
    return Reflect.get(value, 'isSlotEqualConstraint') === true;
}

/**
 * 相等槽口约束（SW：Equal Slots / `swConstraintType_SAMESLOTS`）。
 *
 * 语义（官方原文）：**多个槽口保持长度与半径相等**——改其中一个的尺寸，其余同步。
 * 因此参数求解侧把各槽口的结构标量两两绑等式：
 * 直槽口取「轴长 + 半宽」、圆弧槽口取「中心弧半径 + 半宽」。
 *
 * 几何维持统一由参数方程系统承担；本对象只保存关系身份和目标绑定。
 */
export class SlotEqualConstraint extends MultiTargetRelation<ISketchObject> {
    /** 运行时类型标记。 */
    public readonly isSlotEqualConstraint: boolean = true;

    /** 关系类型。 */
    public relationType = SketchRelationKind.EqualSlot;

    public constructor() {
        super();
        this.name = `${this.baseDisplayName}${count}`;
        count += 1;
    }

    /** 基础显示名。 */
    public get baseDisplayName(): string {
        return '相等槽口';
    }

}
